import React from 'react';

// Hooks
import { useToggle } from 'Shared/utils/hooks';

// Types
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';

// Components
import BaseUserSuggestionItem from './BaseUserSuggestionItem';
import GiveRecognitionModal from 'Shared/components/modals/GiveRecognitionModal/GiveRecognitionModal';

type Props = {
  userSuggestion: UserSuggestion;
  className?: string;
};

const ProvideKudosSuggestion = ({ userSuggestion, className }: Props) => {
  const [isOpen, toggleIsOpen] = useToggle(false);

  const emptyRecognitionRequest = {
    workspaceUuid: null,
    id: null,
    employee: { id: userSuggestion.otherUserId },
  };

  const handleOnClick = () => {
    toggleIsOpen();
  };

  return (
    <>
      <BaseUserSuggestionItem
        userSuggestion={userSuggestion}
        btnLabel="Give Kudos"
        onClick={handleOnClick}
        className={className}
      />
      {isOpen && (
        <GiveRecognitionModal
          choosenRequest={emptyRecognitionRequest}
          isOpen={isOpen}
          onModalToggle={toggleIsOpen}
          userSuggestionId={userSuggestion.slug}
        />
      )}
    </>
  );
};

export default ProvideKudosSuggestion;
